module.exports = __webpack_public_path__ + "img/1_1-parco-2-lago.99c6c364.png";